import React from "react";
import { AHIcon, Box } from "arkh";
import { FilterButtonRole } from "./FilterButtonRole";
import { FilterButtonWeekday } from "./FilterButtonWeekday";
import { DayFilter, RoleFilter } from "./filter";

export function TeamScheduleAdminFilterRow(props: {
  roles: readonly { readonly id: string; readonly name: string }[];
  hasEmployeeRoleFlag: boolean;
  mode: "daily" | "weekly" | "monthly";
  selectedRoleFilter: RoleFilter;
  setSelectedRoleFilter: (role: RoleFilter) => void;
  selectedDaysFilter: DayFilter;
  setSelectedDayFilter: (days: DayFilter) => void;
}) {
  const showRole = props.hasEmployeeRoleFlag && props.roles.length > 0;
  const showWeekday = props.mode === "daily";

  if (!showRole && !showWeekday) {
    return null;
  }

  return (
    <Box
      style={{
        flexDirection: "row",
        alignItems: "center",
        borderBottomWidth: 1,
      }}
      gap="small"
      color="surface"
      spaceBottom="small"
      spaceTop="xxsmall"
      spaceHorizontal="medium"
      borderColor="border-primary"
    >
      <AHIcon type="filter" />
      {showRole && (
        <FilterButtonRole
          selectedRole={props.selectedRoleFilter}
          setSelectedRole={props.setSelectedRoleFilter}
          roles={props.roles}
        />
      )}
      {showWeekday && (
        <FilterButtonWeekday
          selectedDays={props.selectedDaysFilter}
          setSelectedDays={props.setSelectedDayFilter}
        />
      )}
    </Box>
  );
}
